import { ProgressStepName } from '../enums/ProgressStepName';
import { ProgressStep } from '../types/ProgressStep';
import { steps } from './steps';

/**
 *  Represents the sequence of steps in the application progress.
 *  The order of the elements in the array determines the order of the steps in the application progress.
 */
export const progressSteps: ProgressStep[] = [
  steps[ProgressStepName.NEW_APPLICATION],
  steps[ProgressStepName.COMPLETE_APPLICATION],
  steps[ProgressStepName.SUBMITTED_TO_LENDER],
  steps[ProgressStepName.APPROVED_BY_LENDER],
  steps[ProgressStepName.PREPARING_CONTRACTS],
  steps[ProgressStepName.SIGNING_CONTRACTS],
  steps[ProgressStepName.REVIEWING_DOCUMENTS],
  steps[ProgressStepName.FINALIZING_STIPS],
  steps[ProgressStepName.WAITING_ON_FUNDING],
  steps[ProgressStepName.LENDER_FUNDED],
];
